import * as React from 'react';

import ExportArrow16 from './ExportArrow16';

export const exportArrow16 = () => <ExportArrow16 />;

export default {
    title: 'Icon/Fill/ExportArrow16',
    component: ExportArrow16,
    parameters: {
        notes: "`import ExportArrow16 from 'box-ui-elements/es/icon/fill/ExportArrow16';`",
    },
};
